import { h } from 'preact';

/**
 * This contains the "shiny" animated divs, purely cosmetic, first in DOM to be under the buttons
 */
export default function CompactShinyAtoms() {
  const COLORS = ['#3fa7cb', '#feab47', '#85f6bc'];

  return (
    <div role="presentation" aria-hidden="true" className="ftv-magneto--compact-shiny-atomsContainer">
      {COLORS.map((color, index) => (
        <div
          className="ftv-magneto--compact-shiny-remoteAtomWrapper"
          style={{ animationDelay: `${index * 0.1}s` }}
        >
          <div className="ftv-magneto--compact-shiny-remoteAtom" style={{ backgroundColor: color }} />
        </div>
      ))}
    </div>
  );
}
